module.exports = __webpack_public_path__ + "img/accepted-cards.ae408c7a.svg";